/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SuppliersRouteRouteImport } from './routes/suppliers/route'
import { Route as CatalogRouteRouteImport } from './routes/catalog/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SuppliersIndexRouteImport } from './routes/suppliers/index'
import { Route as StoresIndexRouteImport } from './routes/stores/index'
import { Route as StaffIndexRouteImport } from './routes/staff/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as CatalogIndexRouteImport } from './routes/catalog/index'
import { Route as SuppliersIdRouteImport } from './routes/suppliers/$id'
import { Route as CatalogTaxonomyRouteImport } from './routes/catalog/taxonomy'
import { Route as CatalogSplatRouteImport } from './routes/catalog/$'
import { Route as CatalogImportRouteRouteImport } from './routes/catalog/import/route'
import { Route as adminCompaniesRouteRouteImport } from './routes/(admin)/companies/route'
import { Route as CatalogImportIndexRouteImport } from './routes/catalog/import/index'
import { Route as adminUsersIndexRouteImport } from './routes/(admin)/users/index'
import { Route as adminOrganizationsIndexRouteImport } from './routes/(admin)/organizations/index'
import { Route as adminCompaniesIndexRouteImport } from './routes/(admin)/companies/index'
import { Route as CatalogImportAddRouteImport } from './routes/catalog/import/add'
import { Route as CatalogImportIdRouteImport } from './routes/catalog/import/$id'
import { Route as adminCompaniesIdRouteImport } from './routes/(admin)/companies/$id'

const SuppliersRouteRoute = SuppliersRouteRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogRouteRoute = CatalogRouteRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SuppliersIndexRoute = SuppliersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SuppliersRouteRoute,
} as any)
const StoresIndexRoute = StoresIndexRouteImport.update({
  id: '/stores/',
  path: '/stores/',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffIndexRoute = StaffIndexRouteImport.update({
  id: '/staff/',
  path: '/staff/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogIndexRoute = CatalogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CatalogRouteRoute,
} as any)
const SuppliersIdRoute = SuppliersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SuppliersRouteRoute,
} as any)
const CatalogTaxonomyRoute = CatalogTaxonomyRouteImport.update({
  id: '/taxonomy',
  path: '/taxonomy',
  getParentRoute: () => CatalogRouteRoute,
} as any)
const CatalogSplatRoute = CatalogSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => CatalogRouteRoute,
} as any)
const CatalogImportRouteRoute = CatalogImportRouteRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => CatalogRouteRoute,
} as any)
const adminCompaniesRouteRoute = adminCompaniesRouteRouteImport.update({
  id: '/(admin)/companies',
  path: '/companies',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogImportIndexRoute = CatalogImportIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CatalogImportRouteRoute,
} as any)
const adminUsersIndexRoute = adminUsersIndexRouteImport.update({
  id: '/(admin)/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const adminOrganizationsIndexRoute = adminOrganizationsIndexRouteImport.update({
  id: '/(admin)/organizations/',
  path: '/organizations/',
  getParentRoute: () => rootRouteImport,
} as any)
const adminCompaniesIndexRoute = adminCompaniesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => adminCompaniesRouteRoute,
} as any)
const CatalogImportAddRoute = CatalogImportAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => CatalogImportRouteRoute,
} as any)
const CatalogImportIdRoute = CatalogImportIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CatalogImportRouteRoute,
} as any)
const adminCompaniesIdRoute = adminCompaniesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => adminCompaniesRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/catalog': typeof CatalogRouteRouteWithChildren
  '/suppliers': typeof SuppliersRouteRouteWithChildren
  '/companies': typeof adminCompaniesRouteRouteWithChildren
  '/catalog/import': typeof CatalogImportRouteRouteWithChildren
  '/catalog/$': typeof CatalogSplatRoute
  '/catalog/taxonomy': typeof CatalogTaxonomyRoute
  '/suppliers/$id': typeof SuppliersIdRoute
  '/catalog/': typeof CatalogIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/login/': typeof LoginIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/staff/': typeof StaffIndexRoute
  '/stores/': typeof StoresIndexRoute
  '/suppliers/': typeof SuppliersIndexRoute
  '/companies/$id': typeof adminCompaniesIdRoute
  '/catalog/import/$id': typeof CatalogImportIdRoute
  '/catalog/import/add': typeof CatalogImportAddRoute
  '/companies/': typeof adminCompaniesIndexRoute
  '/organizations/': typeof adminOrganizationsIndexRoute
  '/users/': typeof adminUsersIndexRoute
  '/catalog/import/': typeof CatalogImportIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/catalog/$': typeof CatalogSplatRoute
  '/catalog/taxonomy': typeof CatalogTaxonomyRoute
  '/suppliers/$id': typeof SuppliersIdRoute
  '/catalog': typeof CatalogIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/login': typeof LoginIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/staff': typeof StaffIndexRoute
  '/stores': typeof StoresIndexRoute
  '/suppliers': typeof SuppliersIndexRoute
  '/companies/$id': typeof adminCompaniesIdRoute
  '/catalog/import/$id': typeof CatalogImportIdRoute
  '/catalog/import/add': typeof CatalogImportAddRoute
  '/companies': typeof adminCompaniesIndexRoute
  '/organizations': typeof adminOrganizationsIndexRoute
  '/users': typeof adminUsersIndexRoute
  '/catalog/import': typeof CatalogImportIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/catalog': typeof CatalogRouteRouteWithChildren
  '/suppliers': typeof SuppliersRouteRouteWithChildren
  '/(admin)/companies': typeof adminCompaniesRouteRouteWithChildren
  '/catalog/import': typeof CatalogImportRouteRouteWithChildren
  '/catalog/$': typeof CatalogSplatRoute
  '/catalog/taxonomy': typeof CatalogTaxonomyRoute
  '/suppliers/$id': typeof SuppliersIdRoute
  '/catalog/': typeof CatalogIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/login/': typeof LoginIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/staff/': typeof StaffIndexRoute
  '/stores/': typeof StoresIndexRoute
  '/suppliers/': typeof SuppliersIndexRoute
  '/(admin)/companies/$id': typeof adminCompaniesIdRoute
  '/catalog/import/$id': typeof CatalogImportIdRoute
  '/catalog/import/add': typeof CatalogImportAddRoute
  '/(admin)/companies/': typeof adminCompaniesIndexRoute
  '/(admin)/organizations/': typeof adminOrganizationsIndexRoute
  '/(admin)/users/': typeof adminUsersIndexRoute
  '/catalog/import/': typeof CatalogImportIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/catalog'
    | '/suppliers'
    | '/companies'
    | '/catalog/import'
    | '/catalog/$'
    | '/catalog/taxonomy'
    | '/suppliers/$id'
    | '/catalog/'
    | '/dashboard/'
    | '/login/'
    | '/onboarding/'
    | '/settings/'
    | '/staff/'
    | '/stores/'
    | '/suppliers/'
    | '/companies/$id'
    | '/catalog/import/$id'
    | '/catalog/import/add'
    | '/companies/'
    | '/organizations/'
    | '/users/'
    | '/catalog/import/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/catalog/$'
    | '/catalog/taxonomy'
    | '/suppliers/$id'
    | '/catalog'
    | '/dashboard'
    | '/login'
    | '/onboarding'
    | '/settings'
    | '/staff'
    | '/stores'
    | '/suppliers'
    | '/companies/$id'
    | '/catalog/import/$id'
    | '/catalog/import/add'
    | '/companies'
    | '/organizations'
    | '/users'
    | '/catalog/import'
  id:
    | '__root__'
    | '/'
    | '/catalog'
    | '/suppliers'
    | '/(admin)/companies'
    | '/catalog/import'
    | '/catalog/$'
    | '/catalog/taxonomy'
    | '/suppliers/$id'
    | '/catalog/'
    | '/dashboard/'
    | '/login/'
    | '/onboarding/'
    | '/settings/'
    | '/staff/'
    | '/stores/'
    | '/suppliers/'
    | '/(admin)/companies/$id'
    | '/catalog/import/$id'
    | '/catalog/import/add'
    | '/(admin)/companies/'
    | '/(admin)/organizations/'
    | '/(admin)/users/'
    | '/catalog/import/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CatalogRouteRoute: typeof CatalogRouteRouteWithChildren
  SuppliersRouteRoute: typeof SuppliersRouteRouteWithChildren
  adminCompaniesRouteRoute: typeof adminCompaniesRouteRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  StaffIndexRoute: typeof StaffIndexRoute
  StoresIndexRoute: typeof StoresIndexRoute
  adminOrganizationsIndexRoute: typeof adminOrganizationsIndexRoute
  adminUsersIndexRoute: typeof adminUsersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/suppliers': {
      id: '/suppliers'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof SuppliersRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog': {
      id: '/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof CatalogRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suppliers/': {
      id: '/suppliers/'
      path: '/'
      fullPath: '/suppliers/'
      preLoaderRoute: typeof SuppliersIndexRouteImport
      parentRoute: typeof SuppliersRouteRoute
    }
    '/stores/': {
      id: '/stores/'
      path: '/stores'
      fullPath: '/stores/'
      preLoaderRoute: typeof StoresIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff/': {
      id: '/staff/'
      path: '/staff'
      fullPath: '/staff/'
      preLoaderRoute: typeof StaffIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/': {
      id: '/catalog/'
      path: '/'
      fullPath: '/catalog/'
      preLoaderRoute: typeof CatalogIndexRouteImport
      parentRoute: typeof CatalogRouteRoute
    }
    '/suppliers/$id': {
      id: '/suppliers/$id'
      path: '/$id'
      fullPath: '/suppliers/$id'
      preLoaderRoute: typeof SuppliersIdRouteImport
      parentRoute: typeof SuppliersRouteRoute
    }
    '/catalog/taxonomy': {
      id: '/catalog/taxonomy'
      path: '/taxonomy'
      fullPath: '/catalog/taxonomy'
      preLoaderRoute: typeof CatalogTaxonomyRouteImport
      parentRoute: typeof CatalogRouteRoute
    }
    '/catalog/$': {
      id: '/catalog/$'
      path: '/$'
      fullPath: '/catalog/$'
      preLoaderRoute: typeof CatalogSplatRouteImport
      parentRoute: typeof CatalogRouteRoute
    }
    '/catalog/import': {
      id: '/catalog/import'
      path: '/import'
      fullPath: '/catalog/import'
      preLoaderRoute: typeof CatalogImportRouteRouteImport
      parentRoute: typeof CatalogRouteRoute
    }
    '/(admin)/companies': {
      id: '/(admin)/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof adminCompaniesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/import/': {
      id: '/catalog/import/'
      path: '/'
      fullPath: '/catalog/import/'
      preLoaderRoute: typeof CatalogImportIndexRouteImport
      parentRoute: typeof CatalogImportRouteRoute
    }
    '/(admin)/users/': {
      id: '/(admin)/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof adminUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(admin)/organizations/': {
      id: '/(admin)/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof adminOrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(admin)/companies/': {
      id: '/(admin)/companies/'
      path: '/'
      fullPath: '/companies/'
      preLoaderRoute: typeof adminCompaniesIndexRouteImport
      parentRoute: typeof adminCompaniesRouteRoute
    }
    '/catalog/import/add': {
      id: '/catalog/import/add'
      path: '/add'
      fullPath: '/catalog/import/add'
      preLoaderRoute: typeof CatalogImportAddRouteImport
      parentRoute: typeof CatalogImportRouteRoute
    }
    '/catalog/import/$id': {
      id: '/catalog/import/$id'
      path: '/$id'
      fullPath: '/catalog/import/$id'
      preLoaderRoute: typeof CatalogImportIdRouteImport
      parentRoute: typeof CatalogImportRouteRoute
    }
    '/(admin)/companies/$id': {
      id: '/(admin)/companies/$id'
      path: '/$id'
      fullPath: '/companies/$id'
      preLoaderRoute: typeof adminCompaniesIdRouteImport
      parentRoute: typeof adminCompaniesRouteRoute
    }
  }
}

interface CatalogImportRouteRouteChildren {
  CatalogImportIdRoute: typeof CatalogImportIdRoute
  CatalogImportAddRoute: typeof CatalogImportAddRoute
  CatalogImportIndexRoute: typeof CatalogImportIndexRoute
}

const CatalogImportRouteRouteChildren: CatalogImportRouteRouteChildren = {
  CatalogImportIdRoute: CatalogImportIdRoute,
  CatalogImportAddRoute: CatalogImportAddRoute,
  CatalogImportIndexRoute: CatalogImportIndexRoute,
}

const CatalogImportRouteRouteWithChildren =
  CatalogImportRouteRoute._addFileChildren(CatalogImportRouteRouteChildren)

interface CatalogRouteRouteChildren {
  CatalogImportRouteRoute: typeof CatalogImportRouteRouteWithChildren
  CatalogSplatRoute: typeof CatalogSplatRoute
  CatalogTaxonomyRoute: typeof CatalogTaxonomyRoute
  CatalogIndexRoute: typeof CatalogIndexRoute
}

const CatalogRouteRouteChildren: CatalogRouteRouteChildren = {
  CatalogImportRouteRoute: CatalogImportRouteRouteWithChildren,
  CatalogSplatRoute: CatalogSplatRoute,
  CatalogTaxonomyRoute: CatalogTaxonomyRoute,
  CatalogIndexRoute: CatalogIndexRoute,
}

const CatalogRouteRouteWithChildren = CatalogRouteRoute._addFileChildren(
  CatalogRouteRouteChildren,
)

interface SuppliersRouteRouteChildren {
  SuppliersIdRoute: typeof SuppliersIdRoute
  SuppliersIndexRoute: typeof SuppliersIndexRoute
}

const SuppliersRouteRouteChildren: SuppliersRouteRouteChildren = {
  SuppliersIdRoute: SuppliersIdRoute,
  SuppliersIndexRoute: SuppliersIndexRoute,
}

const SuppliersRouteRouteWithChildren = SuppliersRouteRoute._addFileChildren(
  SuppliersRouteRouteChildren,
)

interface adminCompaniesRouteRouteChildren {
  adminCompaniesIdRoute: typeof adminCompaniesIdRoute
  adminCompaniesIndexRoute: typeof adminCompaniesIndexRoute
}

const adminCompaniesRouteRouteChildren: adminCompaniesRouteRouteChildren = {
  adminCompaniesIdRoute: adminCompaniesIdRoute,
  adminCompaniesIndexRoute: adminCompaniesIndexRoute,
}

const adminCompaniesRouteRouteWithChildren =
  adminCompaniesRouteRoute._addFileChildren(adminCompaniesRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CatalogRouteRoute: CatalogRouteRouteWithChildren,
  SuppliersRouteRoute: SuppliersRouteRouteWithChildren,
  adminCompaniesRouteRoute: adminCompaniesRouteRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  StaffIndexRoute: StaffIndexRoute,
  StoresIndexRoute: StoresIndexRoute,
  adminOrganizationsIndexRoute: adminOrganizationsIndexRoute,
  adminUsersIndexRoute: adminUsersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
